import React from 'react';
export function ViewGridIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 11V3h8v8H3zm2-6h4v4H5V5zM3 21v-8h8v8H3zm2-6h4v4H5v-4zm8-12v8h8V3h-8zm6 2h-4v4h4V5zm-6 16v-8h8v8h-8zm2-6h4v4h-4v-4z"
  }));
}